import { render, staticRenderFns } from "./AdDesign.vue?vue&type=template&id=2ba1150c&scoped=true&"
import script from "./AdDesign.vue?vue&type=script&lang=ts&"
export * from "./AdDesign.vue?vue&type=script&lang=ts&"
import style0 from "./AdDesign.vue?vue&type=style&index=0&id=2ba1150c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1150c",
  null
  
)

export default component.exports